import {GROUP_MODAL_VISIBILITY,
        TOGGLE_GROUP_MODAL_VISIBILITY, 
        CREATE_GROUP_SUCCESS, 
        EDIT_GROUP_SUCCESS, 
        DELETE_GROUP_SUCCESS,
        GROUP_PROCESS_FAIL } from '../actions/actionTypes'

const initState = {
    groupingModalOpen : false,
    groupingModalData : {
        modalType: "",
        groupingAction : "",
        groupId : "",
        userGroupId : "",
        indexName: "",
        indexValueType: "",
    },
    submissionResponse : {
        submissionType : "",
        responseType:"",
        responseData: {
            message:"",
            data:[]
        }
    }
}

const groupingModalReducer = (state = initState, action) => {
    // console.log('hotelgroupingmodalreducerstate',state,action.type)
    switch(action.type){
        case GROUP_MODAL_VISIBILITY : return {
            ...state,
            groupingModalOpen : true,
            groupingModalData : action.groupingModalData
        }
        case TOGGLE_GROUP_MODAL_VISIBILITY : return {
            ...state,
            groupingModalOpen : false
        }
        case CREATE_GROUP_SUCCESS : return {
            ...state,
            submissionResponse : {
                submissionType : action.triggerType,
                responseType : "SUCCESS",
                responseData : action.triggerData
            }
        }
        case EDIT_GROUP_SUCCESS : return {
            ...state,
            submissionResponse : {
                submissionType : action.triggerType,
                responseType : "SUCCESS",
                responseData : action.triggerData
            }
        }
        case DELETE_GROUP_SUCCESS : return {
            ...state,
            submissionResponse : {
                submissionType : action.triggerType,
                responseType : "SUCCESS",
                responseData : action.triggerData
            }
        }
        case GROUP_PROCESS_FAIL : return {
            ...state,
            submissionResponse : {
                submissionType : action.triggerType,
                responseType : "FAIL",
                responseData : action.triggerData
            }
        }
        // case resetsubmissionresponse

        default : return state
    }
};

export default groupingModalReducer;